<template>
  <div>
    <b-form novalidate @submit.prevent="onSubmit">
      <b-row>
        <b-col xs="12" md="6">
          <b-card class="mt-3">
            <h4 slot="header">Display</h4>
            <text-control label="Name" v-model="item.name" required min-length="2"></text-control>
            <text-control label="Common Name" v-model="item.commonName" required min-length="2"></text-control>
            <text-control label="Family" v-model="item.family"></text-control>
            <checkbox-control label="Show at End of List" description="If checked, this will appear at the end of lists. Use this for unidentified allergens." v-model="item.showAtEndOfList"></checkbox-control>
            <text-control label="Image" v-model="item.imageName"></text-control>
            <img :src="'/images/' + item.imageName" :alt="item.name" />
          </b-card>
        </b-col>
        <b-col xs="12" md="6">
          <b-card class="mt-3">
            <h4 slot="header">Classification</h4>
            <select-control label="Category" v-model="item.category" :options="categories"></select-control>
            <select-control label="Type" v-model="item.type" :options="types"></select-control>
          </b-card>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <b-button-toolbar key-nav>
            <b-button-group>
              <b-button type="submit" variant="primary">
                <slot name="save"></slot>
              </b-button>
            </b-button-group>
            <b-button-group class="mx-2">
              <b-button type="button" @click="onCancel">Cancel</b-button>
            </b-button-group>
          </b-button-toolbar>
        </b-col>
      </b-row>
      
    </b-form>
  </div>
</template>

<script>
export default {
  name: "AllergenFields",
  props: [
      'item'
  ],
  data() {
    return {
      categories: [
        { "text": "Tree", "value": "TREE" },
        { "text": "Weed", "value": "WEED" },
        { "text": "Grass", "value": "GRASS" },
        { "text": "Mold", "value": "MOLD" },
        { "text": "Unidentified", "value": "UNIDENTIFIED" }
      ],
      types: [
        { "text": "Pollen", "value": "POLLEN" },
        { "text": "Spore", "value": "SPORE" }
      ]
    };
  },
  methods: {
    onCancel(evt) {
      this.$emit('cancel');
    },
    onSubmit(evt) {
      // Make sure all the child components are valid
      if (this.$children.every(childComponent => { return typeof(childComponent.isValid) === 'undefined' || childComponent.isValid; }))
        this.$emit('submit');
    }
  }
};
</script>